"use client";
const STORAGE_KEY = "last-video-played";

export const videoStorage = {
  set(element: HTMLVideoElement | null) {
    const id = element?.id;
    if (!id) return;
    localStorage.setItem(STORAGE_KEY, id);
  },

  get() {
    return localStorage.getItem(STORAGE_KEY);
  },

  delete() {
    return localStorage.removeItem(STORAGE_KEY);
  },
};
